import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';

function OtherKPIReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchName, setBranchName] = useState(0);
    const [selectedBranches, setSelectedBranches] = useState([]); // Use an array for multiple selections
    const [totalNetSales, setTotalNetSales] = useState(0);
    const [totalNumberofPcs, setTotalNumberofPcs] = useState(0);
    const [totalNumberofBills, setTotalNumberofBills] = useState(0);
    const [totalSingleBills, setTotalSingleBills] = useState(0);
    const [totalASP, setTotalASP] = useState(0);
    const [totalUPT, setTotalUPT] = useState(0);
    const [totalVPT, setTotalVPT] = useState(0);
    const [totalPercentageSingleBill, setTotalPercentageSingleBill] = useState(0);
    const [totalNumberofWatches, setTotalNumberofWatches] = useState(0);
    const [totalNumberofJewellery, setTotalNumberofJewellery] = useState(0);
    const [totalASPJewellery, setTotalASPJewellery] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const handleBranchSelect = (selectedOptions) => {
        setSelectedBranches(selectedOptions);
        const branchIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // You can now use branchIds to filter or send to the API
        setDataItem([]); // Clear the data when branches are changed
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };


    const [totalbills, setTotalbills] = useState(0);

    useEffect(() => {
        // Initialize totals
        let totalNetSales = 0;
        let totalNumberofPcs = 0;
        let totalNumberofBills = 0;
        let totalSingleBills = 0;
        let totalPercentageSingleBill = 0;
        let totalNumberofWatches = 0;
        let totalNumberofJewellery = 0;
        let totalASPJewellery = 0;
        let totalNetSalesJewellery = 0;

        // Calculate totals based on dataItem array
        dataItem.forEach(item => {
            totalNetSales += item.NetSales;
            totalNumberofPcs += item.NumberofPcs;
            totalNumberofBills += item.NumberofBills;
            totalSingleBills += item.NumberofSingleBills;
            totalNumberofWatches += item.NumberofWatches;
            totalNumberofJewellery += item.NumberofJewellery;
            totalASPJewellery += item.ASPJewellery;
            totalNetSalesJewellery += item.NetSalesJewellery;
        });

        // Set calculated totals in state
        setTotalNetSales(totalNetSales);
        setTotalNumberofPcs(totalNumberofPcs);
        setTotalNumberofBills(totalNumberofBills);
        setTotalSingleBills(totalSingleBills);
        setTotalNumberofWatches(totalNumberofWatches);
        setTotalNumberofJewellery(totalNumberofJewellery);

        // Calculate ASP, UPT, and VPT
        const totalASP = totalNumberofPcs > 0 ? Math.round(totalNetSales / totalNumberofPcs) : 0;
        const totalUPT = totalNumberofBills > 0 ? (totalNumberofPcs / totalNumberofBills) : 0;
        const totalVPT = totalNumberofBills > 0 ? (totalNetSales / totalNumberofBills) : 0;
        const totalnetjew = totalNumberofJewellery > 0 ? Math.round(totalNetSalesJewellery / totalNumberofJewellery) : 0;

        // Calculate percentage of single bills with one decimal place
        totalPercentageSingleBill = totalNumberofBills > 0 ? ((totalSingleBills * 100) / totalNumberofBills) : 0;

        // Set calculated values in state
        setTotalASP(totalASP);
        setTotalUPT(totalUPT);
        setTotalVPT(totalVPT);
        setTotalPercentageSingleBill(totalPercentageSingleBill);
        setTotalASPJewellery(totalnetjew);
    }, [dataItem]);


    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            let branchIds;

            if (selectedBranches.length === 0) {
                branchIds = branchOptions.map(branch => branch.value);
            } else {
                branchIds = selectedBranches.map(branch => branch.value);
            }
            try {
                const branchIdsString = branchIds.join(',');
                const response = await fetchData('OtherReportApi', `/KPIReport/${companyId}/${branchIdsString}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Daily Sales Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };


    const handleExportExcel = () => {
        const excelData = [];

        // Header information
        const headerCaption = [`KPI Report From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);

        // Column headers for the KPI report
        const headerRow = ['Store', 'Staff Name', 'Net Sales', 'Number of Pcs', 'Number of Bills', 'Number of Single Bills', 'ASP', 'UPT', 'VPT', '% Single Bills', 'Number of Watches', 'ASP Jewellery'];
        excelData.push(headerRow);

        // Data rows from filteredDataItem
        filteredDataItem.forEach(rowData => {
            const dataRow = [
                rowData.StoreName,
                rowData.StaffName,
                rowData.NetSales,
                rowData.NumberofPcs,
                rowData.NumberofBills,
                rowData.NumberofSingleBills,
                rowData.ASP,
                rowData.UPT,  // Format UPT to 3 decimal places
                rowData.VPT,
                rowData.PercentageSingleBill,  // Percentage of Single Bills
                rowData.NumberofWatches,
                // rowData.NumberofJewellery,
                rowData.ASPJewellery,
            ];
            excelData.push(dataRow);
        });

        // Add total row
        const totalRow = [
            '', 'Total',
            totalNetSales,
            totalNumberofPcs,
            totalNumberofBills,
            totalSingleBills,
            totalASP,
            parseFloat(totalUPT.toFixed(3)),
            parseFloat(totalVPT.toFixed(0)),
            parseFloat(totalPercentageSingleBill.toFixed(1)),
            totalNumberofWatches,
            // totalNumberofJewellery,
            totalASPJewellery,

        ];
        excelData.push(totalRow);

        // Group by StoreName and calculate totals per store
        const storeTotals = {};



        filteredDataItem.forEach(rowData => {
            if (!storeTotals[rowData.StoreName]) {
                storeTotals[rowData.StoreName] = {
                    NetSales: 0,
                    NumberofPcs: 0,
                    NumberofBills: 0,
                    NumberofSingleBills: 0,
                    NumberofWatches: 0,
                    NumberofJewellery: 0,
                    NumberofNetSalesJewellery: 0,
                };
            }

            // Accumulate individual totals for each store
            storeTotals[rowData.StoreName].NetSales += rowData.NetSales;
            storeTotals[rowData.StoreName].NumberofPcs += rowData.NumberofPcs;
            storeTotals[rowData.StoreName].NumberofBills += rowData.NumberofBills;
            storeTotals[rowData.StoreName].NumberofSingleBills += rowData.NumberofSingleBills;
            storeTotals[rowData.StoreName].NumberofWatches += rowData.NumberofWatches;
            storeTotals[rowData.StoreName].NumberofJewellery += rowData.NumberofJewellery;
            storeTotals[rowData.StoreName].NumberofNetSalesJewellery += rowData.NetSalesJewellery;
        });

        // Now calculate ASP, UPT, VPT, and PercentageSingleBill based on aggregated totals
        Object.keys(storeTotals).forEach(storeName => {
            const storeData = storeTotals[storeName];

            // ASP: NetSales / Number of Pcs
            storeData.ASP = storeData.NumberofPcs > 0 ? Math.round(storeData.NetSales / storeData.NumberofPcs) : 0;

            // UPT: Number of Pcs / Number of Bills
            storeData.UPT = storeData.NumberofBills > 0 ? (storeData.NumberofPcs / storeData.NumberofBills).toFixed(3) : "0.000";

            // VPT: Net Sales / Number of Bills
            storeData.VPT = storeData.NumberofBills > 0 ? (storeData.NetSales / storeData.NumberofBills).toFixed(0) : "0";

            // Percentage of Single Bills: (Number of Single Bills / Number of Bills) * 100
            storeData.PercentageSingleBill = storeData.NumberofBills > 0 ? ((storeData.NumberofSingleBills * 100) / storeData.NumberofBills).toFixed(1) : "0.0";
            storeData.ASPJewellery = storeData.NumberofJewellery > 0 ? Math.round(storeData.NumberofNetSalesJewellery / storeData.NumberofJewellery) : 0;
        });


        // Add empty rows and new section for store totals
        excelData.push([], []);  // Two empty rows
        const storeHeaderRow = [' ', 'Store', 'Net Sales', 'Number of Pcs', 'Number of Bills', 'Number of Single Bills', 'ASP', 'UPT', 'VPT', '% Single Bills', 'Number of Watches', 'ASP Jewellery'];
        excelData.push(storeHeaderRow);

        // Add store totals rows
        Object.keys(storeTotals).forEach(storeName => {
            const storeRow = [
                '',  // Skip Store column for this summary
                storeName,
                storeTotals[storeName].NetSales,
                storeTotals[storeName].NumberofPcs,
                storeTotals[storeName].NumberofBills,
                storeTotals[storeName].NumberofSingleBills,
                storeTotals[storeName].ASP,
                parseFloat(storeTotals[storeName].UPT),
                parseFloat(storeTotals[storeName].VPT),
                parseFloat(storeTotals[storeName].PercentageSingleBill),
                storeTotals[storeName].NumberofWatches,
                // storeTotals[storeName].NumberofJewellery,
                storeTotals[storeName].ASPJewellery,
            ];
            excelData.push(storeRow);
        });

        // Add final total row
        const totalRow1 = [
            '', 'Total',
            totalNetSales,
            totalNumberofPcs,
            totalNumberofBills,
            totalSingleBills,
            totalASP,
            parseFloat(totalUPT.toFixed(3)),
            parseFloat(totalVPT.toFixed(0)),
            parseFloat(totalPercentageSingleBill.toFixed(1)),
            totalNumberofWatches,
            // totalNumberofJewellery,
            totalASPJewellery,
        ];
        excelData.push(totalRow1);

        // Create worksheet and workbook
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Apply formatting: 3 decimal places for UPT (column index 7) and 1 decimal place for % Single Bills (column index 9)
        for (let i = 2; i < excelData.length; i++) {  // Skip first 2 header rows
            const uptCell = ws[XLSX.utils.encode_cell({ r: i, c: 7 })];  // UPT column
            if (uptCell) {
                uptCell.z = '0.000';  // Format to 3 decimal places
            }

            const percentageSingleBillsCell = ws[XLSX.utils.encode_cell({ r: i, c: 9 })];  // % Single Bills column
            if (percentageSingleBillsCell) {
                percentageSingleBillsCell.z = '0.0';  // Format to 1 decimal place
            }
        }

        // Create workbook and export the file
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'KPI Report');
        XLSX.writeFile(wb, 'KPIReport.xlsx');
    };



    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', width: '250px' }}>
                        KPI Report
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '-10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>
                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '275px' }}
                            />
                        )}
                    </div>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '50px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranches}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        isMulti
                        style={{ width: '100%', marginTop: '-11px' }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Store </TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Staff Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Sales</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Number of Pcs</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Number of Bills</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Number of Single Bills</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>ASP</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>UPT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>VPT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>% Single Bills</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Number of Watches</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>ASP Jewellery</TableCell>

                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '7px',
                                        height: '52px',

                                        backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.StoreName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.StaffName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NetSales}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NumberofPcs}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NumberofBills}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NumberofSingleBills}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ASP}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{Number(data.UPT).toFixed(3)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.VPT}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{Number(data.PercentageSingleBill).toFixed(1)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NumberofWatches}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ASPJewellery}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '40px',

                                    backgroundColor: 'teal',

                                }}
                            >
                                <TableCell colSpan={1} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '14px', textTransform: 'uppercase' }}>Total</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalNetSales}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalNumberofPcs}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalNumberofBills}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalSingleBills}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalASP}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalUPT.toFixed(3)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalVPT.toFixed(0)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalPercentageSingleBill.toFixed(1)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalNumberofWatches}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalASPJewellery}</TableCell>


                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


        </div>
    );
}

export default OtherKPIReport;
